"use strict"
angular.module("manageSysOneKeyWithdrawRouterModule", [])
    .config(["$stateProvider", function($stateProvider) {
    	$stateProvider.state('manageconfig.sysmanage.onekeywithdraw', {
    		url: '/onekeywithdraw',
    		views: {
    			'main@manageconfig.sysmanage': {
    				templateUrl: './manageConfig/sysManageMent/oneKeyWithdraw/oneKeyWithdraw_tpl.html',
    				controller: 'oneKeyWithdrawCtrl'
    			}
    		}
    	}).state('manageconfig.sysmanage.onekeywithdraw.onekeywithdrawlog', {
            url: '/onekeywithdrawlog',
            views: {
                'main@manageconfig.sysmanage': {
                    templateUrl: './manageConfig/sysManageMent/oneKeyWithdraw/oneKeyWithdrawLog/oneKeyWithdrawLog_tpl.html',
                    controller: 'manageSysOneKeyWithdrawLogCtrl'
                }
            }
        }).state('manageconfig.sysmanage.onekeywithdraw.onekeywithdrawdetail', {
            url: '/onekeywithdrawdetail',
            views: {
                'main@manageconfig.sysmanage': {
                    templateUrl: './manageConfig/sysManageMent/oneKeyWithdraw/oneKeyWithdrawDetail/oneKeyWithdrawDetail_tpl.html',
                    controller: 'manageSysOneKeyWithdrawDetailCtrl'
                }
            }
        })
    }]);